export default "__VITE_ASSET__b33be8f8__"